export enum BoxesRoutesEnum {
  LIST= '',
  CREATE = 'create',
  BATCH_CREATE = 'create/batch',
  EDIT = 'edit/:boxId'
}
